// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-menu {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translate(-30%, 0);
  z-index: 1;
  min-width: 11rem;
  height: 2.5rem;
  border-radius: 1.333rem;
  cursor: pointer;
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 1.5rem;
  padding-right: 2.5rem;
}
.bottom-menu.open {
  border-radius: 0 0 1.333rem 1.333rem;
}
.bottom-menu.notBrekTask {
  padding-left: 3rem;
  padding-right: 3rem;
}
.bottom-menu .goto-coffee-break .btn {
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-primary-blue);
  border-radius: 0.667rem;
  cursor: pointer;
}
.bottom-menu .goto-coffee-break .tip {
  position: absolute;
  width: 200px;
  height: 90px;
  bottom: 80px;
  right: 90px;
  display: flex;
  align-items: flex-end;
}
.bottom-menu .goto-coffee-break .tip .info {
  font-size: 9px;
  font-weight: 400;
  color: #ffffff;
  display: inline-block;
  line-height: 140%;
  padding: 0 0 10px 15px;
}
.bottom-menu .goto-coffee-break .tip .arrow {
  width: 35px;
}
.bottom-menu .coffee-break-tasks {
  font-size: 0.9rem;
}
.bottom-menu .coffee-break-tasks .arrow-up {
  position: absolute;
  top: 50%;
  transform: translate(0px, -50%);
  right: 0.208rem;
  width: 2rem;
  height: 2rem;
}
.bottom-menu .coffee-break-tasks .arrow-up.open {
  transform: rotate(180deg);
  top: 0.208rem;
}
.bottom-menu .coffee-break-tasks .tasks-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  min-width: 23rem;
  border-radius: 0.333rem;
  padding: 0.5rem;
  background: var(--color-yellow-bookmark);
}
.bottom-menu .coffee-break-tasks .tasks-menu .item {
  display: flex;
  white-space: nowrap;
  align-items: center;
  background: #ffffff;
  width: 100%;
  height: 2rem;
  border-radius: 0.333rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-primary-blue);
  padding: 0.583rem 0.667rem;
}
.bottom-menu .coffee-break-tasks .tasks-menu .item:not(:first-of-type) {
  margin-top: 6px;
}
.bottom-menu .coffee-break-tasks .tasks-menu .item::before {
  content: "";
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #f9ebb1;
  margin-right: 0.333rem;
}
.bottom-menu .coffee-break-tasks .tasks-menu .item.-completed {
  background: #f9ebb1;
  color: #497845;
  pointer-events: none;
}
.bottom-menu .coffee-break-tasks .tasks-menu .item.-completed::before {
  background: url('item-completed.46c481b01c699930.svg') center center no-repeat;
  background-size: 1rem 1rem;
}
.bottom-menu .coffee-break-tasks .tasks-menu .item:not(.-completed) {
  cursor: pointer;
}
.bottom-menu .coffee-break-tasks .tasks-menu .item .-hide {
  display: none;
}
.bottom-menu .coffee-break-tasks .last-coffee {
  display: flex;
  position: absolute;
  top: -1.4rem;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center;
  padding-top: 0.2rem;
  width: 8rem;
  height: 1.4rem;
  color: #ffffff;
  font-size: 0.6rem;
  font-weight: 600;
  background-image: url('exclamation-icon.1176e7caa54811d4.svg');
  background-position: 8px 6px;
  background-repeat: no-repeat;
  background-size: 0.8rem auto;
  padding-left: 1rem;
  z-index: 1;
}

.modal {
  position: absolute;
  bottom: 0.5rem;
  z-index: 100;
  width: 16.667rem;
}

.timer-sec {
  position: absolute;
  bottom: 6.7rem;
  left: 83%;
  font-size: 1rem;
  color: #3266cc;
  text-align: right;
  z-index: 100;
}

.color-text {
  position: absolute;
  bottom: 4.8rem;
  left: 5%;
  font-size: 0.8rem;
  color: #003399;
  z-index: 100;
  text-align: center;
}

.game-name-text {
  position: absolute;
  bottom: 6.7rem;
  left: 5%;
  z-index: 100;
  font-size: 1rem;
  color: #ffffff;
  width: 11rem;
}

.flag1 {
  position: absolute;
  bottom: 1.2rem;
  left: 13%;
  width: 3.2rem;
  z-index: 100;
}
.flag1.flag2 {
  left: 40%;
}
.flag1.flag3 {
  left: 67%;
}

.image-box {
  position: absolute;
  bottom: 0rem;
  left: 42%;
  z-index: 100;
  width: 18.667rem;
  height: 8.917rem;
}
.image-box .text-row {
  display: flex;
  align-items: center;
  height: 2.333rem;
}
.image-box .text-row .success {
  background: #83BB18 !important;
}
.image-box .text-row .error {
  background: #dd5349 !important;
}
.image-box .text-row .col-75 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75%;
  height: 100%;
  background: var(--color-primary-blue);
  padding: 0.35rem;
  border-top-left-radius: 0.667rem;
}
.image-box .text-row .col-75 .text {
  color: white;
  font-size: 1rem;
  font-weight: 600;
}
.image-box .text-row .col-25 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25%;
  height: 100%;
  background: white;
  border-top-right-radius: 0.667rem;
}
.image-box .text-row .col-25 .clock {
  height: 100%;
  display: flex;
  align-items: center;
}
.image-box .text-row .col-25 .clock .icon {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}
.image-box .text-row .col-25 .seconds {
  color: var(--color-primary-blue);
  font-size: 1rem;
  font-weight: 600;
}
.image-box .yellow-background {
  background: var(--color-yellow-bookmark) linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  min-height: 5.583rem;
}
.image-box .yellow-background .subtitle {
  font-size: 0.8rem;
  color: var(--color-primary-blue);
  text-align: center;
  padding: 0.4rem 0.4rem 0 0.4rem;
  height: 2.458rem;
}
.image-box .yellow-background .flag-row {
  display: flex;
  height: 3.517rem;
  justify-content: space-evenly;
  padding-top: 0.5rem;
}
.image-box .yellow-background .flag-row .box {
  width: 3rem;
  height: 3rem;
  border: 2px dashed #326699;
  border-radius: 0.333rem;
}
.image-box .yellow-background .flag-row .box.selected {
  border: 2px solid #326699;
}
.image-box .yellow-background .flag-row .box img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 0.133rem;
}

.bg-blue {
  background: #003399;
  border-radius: 0.8rem 0.8rem 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/coffee-break-bar/coffee-break-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,yHAAA;EAMA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;AAJF;AAME;EACE,oCAAA;AAJJ;AAOE;EACE,kBAAA;EACA,mBAAA;AALJ;AASI;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;AAPN;AAUI;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;AARN;AAUM;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;AARR;AAWM;EACE,WAAA;AATR;AAcE;EACE,iBAAA;AAZJ;AAcI;EACE,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAZN;AAcM;EACE,yBAAA;EACA,aAAA;AAZR;AAgBI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,wCAAA;AAdN;AAgBM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;AAdR;AAgBQ;EACE,eAAA;AAdV;AAiBQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAfV;AAkBQ;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;AAhBV;AAkBU;EACE,8EAAA;EAEA,0BAAA;AAjBZ;AAqBQ;EACE,eAAA;AAnBV;AAsBQ;EACE,aAAA;AApBV;AAyBI;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EAEA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,8DAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,UAAA;AAxBN;;AA6BA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;AA1BF;AA4BE;EACE,SAAA;AA1BJ;AA6BE;EACE,SAAA;AA3BJ;;AA+BA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA5BF;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA5BJ;AA8BI;EACE,8BAAA;AA5BN;AA+BI;EACE,8BAAA;AA7BN;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,gCAAA;AA9BN;AAgCM;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AA9BR;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;AAhCN;AAkCM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAhCR;AAkCQ;EACE,aAAA;EACA,cAAA;EACA,oBAAA;AAhCV;AAoCM;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;AAlCR;AAuCE;EACE,2HAAA;EACA,oBAAA;AArCJ;AAuCI;EACE,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;AArCN;AAwCI;EACE,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AAtCN;AAwCM;EACE,WAAA;EACA,YAAA;EACA,0BAAA;EACA,uBAAA;AAtCR;AAwCQ;EACE,yBAAA;AAtCV;AAyCQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAvCV;;AA8CA;EACE,mBAAA;EACA,gCAAA;AA3CF","sourcesContent":[".bottom-menu {\n  position: absolute;\n  bottom: 1rem;\n  left: 50%;\n  transform: translate(-30%, 0);\n  z-index: 1;\n  min-width: 11rem;\n  height: 2.5rem;\n  border-radius: 1.333rem;\n  cursor: pointer;\n  background: var(--color-yellow-bookmark)\n    linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.48) 100%\n    );\n  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 1.5rem;\n  padding-right: 2.5rem;\n\n  &.open {\n    border-radius: 0 0 1.333rem 1.333rem;\n  }\n\n  &.notBrekTask {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n\n  .goto-coffee-break {\n    .btn {\n      font-size: 1rem;\n      font-weight: 700;\n      color: var(--color-primary-blue);\n      border-radius: 0.667rem;\n      cursor: pointer;\n    }\n\n    .tip {\n      position: absolute;\n      width: 200px;\n      height: 90px;\n      bottom: 80px;\n      right: 90px;\n      display: flex;\n      align-items: flex-end;\n\n      .info {\n        font-size: 9px;\n        font-weight: 400;\n        color: #ffffff;\n        display: inline-block;\n        line-height: 140%;\n        padding: 0 0 10px 15px;\n      }\n\n      .arrow {\n        width: 35px;\n      }\n    }\n  }\n\n  .coffee-break-tasks {\n    font-size: 0.9rem;\n\n    .arrow-up {\n      position: absolute;\n      top: 50%;\n      transform: translate(0px, -50%);\n      right: 0.208rem;\n      width: 2rem;\n      height: 2rem;\n\n      &.open {\n        transform: rotate(180deg);\n        top: 0.208rem;\n      }\n    }\n\n    .tasks-menu {\n      position: absolute;\n      display: flex;\n      flex-direction: column;\n      bottom: 2.5rem;\n      left: 50%;\n      transform: translateX(-50%);\n      z-index: 2;\n      min-width: 23rem;\n      border-radius: 0.333rem;\n      padding: 0.5rem;\n      background: var(--color-yellow-bookmark);\n\n      .item {\n        display: flex;\n        white-space: nowrap;\n        align-items: center;\n        background: #ffffff;\n        width: 100%;\n        height: 2rem;\n        border-radius: 0.333rem;\n        font-size: 1rem;\n        font-weight: 600;\n        color: var(--color-primary-blue);\n        padding: 0.583rem 0.667rem;\n\n        &:not(:first-of-type) {\n          margin-top: 6px;\n        }\n\n        &::before {\n          content: \"\";\n          width: 1rem;\n          height: 1rem;\n          border-radius: 50%;\n          background: #f9ebb1;\n          margin-right: 0.333rem;\n        }\n\n        &.-completed {\n          background: #f9ebb1;\n          color: #497845;\n          pointer-events: none;\n\n          &::before {\n            background: url(\"../../../assets/coffee-break/item-completed.svg\")\n              center center no-repeat;\n            background-size: 1rem 1rem;\n          }\n        }\n\n        &:not(.-completed) {\n          cursor: pointer;\n        }\n\n        .-hide {\n          display: none;\n        }\n      }\n    }\n\n    .last-coffee {\n      display: flex;\n      position: absolute;\n      top: -1.4rem;\n      left: 50%;\n      transform: translateX(-50%);\n      justify-content: center;\n      padding-top: 0.2rem;\n      width: 8rem;\n      height: 1.4rem;\n      // border-radius: 12px 12px 0 0;\n      color: #ffffff;\n      font-size: 0.6rem;\n      font-weight: 600;\n      background-image: url(\"../../../assets/coffee-break/exclamation-icon.svg\");\n      background-position: 8px 6px;\n      background-repeat: no-repeat;\n      background-size: 0.8rem auto;\n      padding-left: 1rem;\n      z-index: 1;\n    }\n  }\n}\n\n.modal {\n  position: absolute;\n  bottom: 0.5rem;\n  z-index: 100;\n  width: 16.667rem;\n}\n\n.timer-sec {\n  position: absolute;\n  bottom: 6.7rem;\n  left: 83%;\n  font-size: 1rem;\n  color: #3266cc;\n  text-align: right;\n  z-index: 100;\n}\n\n.color-text {\n  position: absolute;\n  bottom: 4.8rem;\n  left: 5%;\n  font-size: 0.8rem;\n  color: #003399;\n  z-index: 100;\n  text-align: center;\n}\n\n.game-name-text {\n  position: absolute;\n  bottom: 6.7rem;\n  left: 5%;\n  z-index: 100;\n  font-size: 1rem;\n  color: #ffffff;\n  width: 11rem;\n}\n\n.flag1 {\n  position: absolute;\n  bottom: 1.2rem;\n  left: 13%;\n  width: 3.2rem;\n  z-index: 100;\n\n  &.flag2 {\n    left: 40%;\n  }\n\n  &.flag3 {\n    left: 67%;\n  }\n}\n\n.image-box {\n  position: absolute;\n  bottom: 0rem;\n  left: 42%;\n  z-index: 100;\n  width: 18.667rem;\n  height: 8.917rem;\n\n  .text-row {\n    display: flex;\n    align-items: center;\n    height: 2.333rem;\n\n    .success {\n      background: #83BB18 !important;\n    }\n\n    .error {\n      background: #dd5349 !important;\n    }\n\n    .col-75 {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 75%;\n      height: 100%;\n      background: var(--color-primary-blue);\n      padding: 0.35rem;\n      border-top-left-radius: 0.667rem;\n\n      .text {\n        color: white;\n        font-size: 1rem;\n        font-weight: 600;\n      }\n    }\n\n    .col-25 {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 25%;\n      height: 100%;\n      background: white;\n      border-top-right-radius: 0.667rem;\n\n      .clock {\n        height: 100%;\n        display: flex;\n        align-items: center;\n\n        .icon {\n          width: 1.5rem;\n          height: 1.5rem;\n          margin-right: 0.5rem;\n        }\n      }\n\n      .seconds {\n        color: var(--color-primary-blue);\n        font-size: 1rem;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .yellow-background {\n    background: var(--color-yellow-bookmark) linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.48) 100%);\n    min-height: 5.583rem;\n\n    .subtitle {\n      font-size: 0.8rem;\n      color: var(--color-primary-blue);\n      text-align: center;\n      padding: 0.4rem 0.4rem 0 0.4rem;\n      height: 2.458rem;\n    }\n\n    .flag-row {\n      display: flex;\n      height: 3.517rem;\n      justify-content: space-evenly;\n      padding-top: 0.5rem;\n\n      .box {\n        width: 3rem;\n        height: 3rem;\n        border: 2px dashed #326699;\n        border-radius: 0.333rem;\n\n        &.selected {\n          border: 2px solid #326699;\n        }\n\n        img {\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n          border-radius: 0.133rem;\n        }\n      }\n    }\n  }\n}\n\n.bg-blue {\n  background: #003399;\n  border-radius: 0.8rem 0.8rem 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
